module.exports = __webpack_public_path__ + "img/6.55b998c5.jpg";